var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVaultDark = function SvgVaultDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M12.857 8.8c.395 0 .714-.358.714-.8s-.32-.8-.714-.8-.714.358-.714.8.32.8.714.8M0 4c0-2.21 1.599-4 3.571-4H16.43C18.4 0 20 1.79 20 4v8c0 2.21-1.599 4-3.571 4H3.57C1.6 16 0 14.21 0 12zm5 .8c-.394 0-.714.358-.714.8v4.8c0 .442.32.8.714.8s.714-.358.714-.8V5.6c0-.442-.32-.8-.714-.8m9.791 4.235C14.925 8.72 15 8.37 15 8s-.075-.721-.209-1.035l.714-.8a.87.87 0 0 0 0-1.13.662.662 0 0 0-1.01 0l-.714.799a1.95 1.95 0 0 0-1.848 0l-.714-.8a.662.662 0 0 0-1.01 0 .87.87 0 0 0 0 1.132l.714.8A2.6 2.6 0 0 0 10.714 8c0 .37.075.721.21 1.035l-.715.8a.87.87 0 0 0 0 1.13.662.662 0 0 0 1.01 0l.714-.799a1.95 1.95 0 0 0 1.848 0l.714.8a.662.662 0 0 0 1.01 0 .87.87 0 0 0 0-1.132z"
  })));
};
export default SvgVaultDark;